import {useMutation} from '@tanstack/react-query';
import {apiClient} from '../../http/query-client';

export interface PreviewRegisterVoucherResponse {
  valid: boolean;
  message?: string;
  voucher?: {
    id: number;
    code: string;
    discount_percentage: number;
    company_name: string;
  };
  plan?: {
    product_id: number;
    product_name: string;
    price_id: number;
    interval: string;
  };
  pricing?: {
    original_price: number;
    discount_amount: number;
    final_price: number;
    discount_percentage: number;
    currency?: string;
  };
}

export interface PreviewRegisterVoucherPayload {
  voucher_code: string;
}

export function usePreviewRegisterVoucher() {
  return useMutation({
    mutationFn: (payload: PreviewRegisterVoucherPayload) =>
      apiClient
        .post<PreviewRegisterVoucherResponse>('vouchers/preview-register', payload)
        .then(r => r.data),
  });
}
